import { Component } from '@angular/core';
import { faCalendar, faCalendarDays, faList, faClipboardList, faLocationDot, faUser, faClock, faHourglassHalf, faXmark } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { AssignmentDisplaytModel } from 'src/app/models/assignmentDisplay.model';

import { FilterAssignmentModel } from 'src/app/models/filterAssignment.model';
import { AssignmnetService } from '../assignmnet.service';
import { Observable, catchError, map, of, tap } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-assignment-property-owner',
  templateUrl: './assignment-property-owner.component.html',
  styleUrls: ['./assignment-property-owner.component.css']
})
export class AssignmentPropertyOwnerComponent {
  faCalendar = faCalendar;
  faCalendarDays = faCalendarDays;
  faList = faList;
  faClipboardList = faClipboardList;

  faLocationDot = faLocationDot;
  faUser = faUser;
  faClock = faClock;
  faHourglassHalf = faHourglassHalf;
  faXmark = faXmark;

  isLoading = false;
  hideErrorMessage = true;
  errorMessage = '';

  assignmentsModel: AssignmentDisplaytModel[];

  // Create a FilterAssignmentModel object
  filter: FilterAssignmentModel;

  constructor(private route: ActivatedRoute, private assignmentService: AssignmnetService) { }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.onAssignmentsReceived(data.assignmentData);
    });

    // Calculate today's date
    const today = new Date();
    // Calculate the date 30 days from today
    const endDate = new Date();
    endDate.setDate(today.getDate() + 30);
    this.filter = new FilterAssignmentModel(10, 1, today, endDate, false, []);
  }

  onAssignmentsReceived(assignments: AssignmentDisplaytModel[]) {
    this.assignmentsModel = assignments;
  }

  onApplyFilter(newFilter: FilterAssignmentModel) {
    console.log(newFilter);

    this.assignmentService.getPropertyOwnerAssignments(newFilter).pipe(
      tap(_ => { this.filter = newFilter; this.isLoading = true; }),
      map(response => this.onAssignmentsLoaded(response)),
      catchError(this.handleError<FilterAssignmentModel>('getPropertOwnerAssignments'))
    ).subscribe();
  }

  onAssignmentsLoaded(fetchedAssignments: AssignmentDisplaytModel[]) { 
    this.assignmentsModel = fetchedAssignments;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      this.hideErrorMessage = false;
      this.isLoading = false;

      this.errorMessage = error?.error;

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


}
